// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TypographyProps } from "@insite/mobius/Typography";
import { jettingAppProductCardStyles } from "@stoneage/App/Components/JettingAppComponents/JettingAppProductCard";
import { IconWrapper } from "@stoneage/MobiusOverrides/Icon";
import ArrowRight from "@stoneage/XDL/Icons/ArrowRight";
import { color, ellipsis } from "@stoneage/XDL/Utilities";
import { createLinkIconStyles } from "@stoneage/XDL/Utilities/SharedStyles/sharedStyles";
import { css } from "styled-components";

jettingAppProductCardStyles.imageAndDescription = {
    css: css`
        display: flex;
        gap: 16px;
        margin-bottom: 16px;
    `,
};

jettingAppProductCardStyles.productTitle = {
    variant: "h5",
    css: css`
        margin-bottom: 4px;
    `,
};

jettingAppProductCardStyles.leftPart = {
    css: css`
        width: 88px;
        height: 88px;
    `,
};

jettingAppProductCardStyles.image = {
    css: css`
        width: 88px;
        height: 88px;
        img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            border: 1px solid ${color("common.ui5")};
        }
    `,
};
jettingAppProductCardStyles.productPartNumbers = {
    erpNumberWrapper: {
        css: css`
            span[data-test-selector^="productNumber"] {
                color: ${color("common.ui1")};
            }
        `,
    },
    container: {
        css: css`
            display: flex;
            flex-direction: column;
            row-gap: 4px;
            .item-cont {
                display: flex;
            }
        `,
    },
};

const sharedTextStyles: TypographyProps = {
    variant: "p",
    size: 12,
    color: "text",
    css: css`
        letter-spacing: 0;
        line-height: 18px;
        margin-bottom: 0;
        text-transform: none;
    `,
};

jettingAppProductCardStyles.partNumber = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            width: auto;
        `,
    },
    heading: {
        ...sharedTextStyles,
        css: css`
            ${sharedTextStyles.css}
            display: flex;
            &:after {
                content: ":";
                margin-right: 4px;
            }
        `,
    },
    text: {
        ...sharedTextStyles,
        css: css`
            ${sharedTextStyles.css}
            ${wrapInContainerStyles}
            width: auto;
            font-weight: bold;
        `,
    },
};
jettingAppProductCardStyles.rightPart = {
    css: css`
        flex-grow: 1;
    `,
};
jettingAppProductCardStyles.link = {
    ...createLinkIconStyles(ArrowRight, "small", "left", {
        css: css`
            margin-top: 8px;
        `,
        typographyProps: {
            lineHeight: "14px",
        },
        icon: {
            iconProps: {
                css: css`
                    svg {
                        transform: rotate(180deg);
                    }
                `,
            },
        },
    }),
};
